export enum ShipmentTypes {
  "QUOTE" = "QUOTE",
  "SHIPMENT" = "SHIPMENT",
}
